import classNames from 'clsx';
import React, { useEffect } from 'react';
import CreditCardComponent from '../../reservation-payment/CreditCardComponent.react';
import PaymentSummary from './PaymentMethod/PaymentSummary.react';
import { PAYMENT_TYPE } from 'arbitrip-common/general/constants';
import ReservationActions from '../../../../actions/ReservationActions';
import { CURRENCIES } from '@arbitrip/constants';

const SettlePaymentCreditCard = ({ profile, booking, chargeCurrency, nameState }) => {

	useEffect(() => {
		generateCreditUrl();
	}, []);
	
	const generateCreditUrl = () => {
		const existingLoyaltyPoints = booking.payment?.loyalty?.points;
		const params = {
			payment_type: PAYMENT_TYPE.PAY_LATER,
			hotel: booking.hotel,
			reservation: booking,
			charge_currency: chargeCurrency,
			...((nameState?.name || nameState?.otherName) && { invoice_name: nameState.name || nameState.otherName }), // send invoice_name only when there is explicit invoice name
			...(nameState?.invoiceId && { invoice_id: nameState.invoiceId }), // send invoice_id only when there is explicit invoice icount entity
			...(existingLoyaltyPoints > 0 && { show_points: true, user_chosen_points: existingLoyaltyPoints }),
		};

		ReservationActions.payLaterReservation(profile, params);
	};

	return (
		<div className={classNames("settle-payment-wrap", "credit-card", { "wide": chargeCurrency !== CURRENCIES.ILS})}>
			<div className="summary">
				<PaymentSummary profile={profile} booking={booking} chargeCurrency={chargeCurrency} />
			</div>
			<CreditCardComponent profile={profile} />
		</div>
	);
};

export default SettlePaymentCreditCard;
